import { render } from "./BottomBarMobileMore.vue?vue&type=template&id=38313e24&scoped=true"
import script from "./BottomBarMobileMore.vue?vue&type=script&lang=js"
export * from "./BottomBarMobileMore.vue?vue&type=script&lang=js"

import "./BottomBarMobileMore.vue?vue&type=style&index=0&id=38313e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38313e24"]])

export default __exports__